export default __webpack_public_path__ + "static/cover-texture-b838eaa65bfb569180d3d02b1ed6c467.png";